import React, {Component} from 'react';
import {connect} from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import {Carousel} from 'react-responsive-carousel';
import Zoom from "react-medium-image-zoom";
import {Col, Collapse, Row} from "reactstrap";
import classnames from "classnames";
import videojs from 'video.js'
import LoadingBar from "react-top-loading-bar";
import {VideoPlayer} from "../../../../components/clipstore/broadcaster/library/video-player";
import assets from "../../../../util/assets";
import HomeCardComponent from "../../../../components/clipstore/user/home/card";
import "./index.css";
import api from "../../../../util/clipstore/user/api";
import video_util from "../../../../util/clipstore/user/video_details";
import * as actions from "../../../../actions";
import MoreVideo from "../../../../components/clipstore/user/more/video";
import library from "../../../../util/clipstore/broadcaster/library";
import pricing from "../../../../util/clipstore/user/pricing";
import {PremiumContentModal} from "../../../../components/modal/clipstore/user/premiumContentModal";
import {isEmpty, vuepayAlert} from "../../../../util/utility";
import {getEncryptedIdForBroadcaster} from "../../../../util/broadcast_util";
import Comments from "../../../Comments";
import LikeContainer from "../../../like";
import {getData, LOGIN} from "../../../../util/storage";
import {get as _get} from "lodash";

class VideoDetails extends Component {

    getPlayer = () => {
        const vjs_video_3_html5_api = document.getElementById("vjs_video_3_html5_api");
        if (vjs_video_3_html5_api) {
            return videojs('vjs_video_3_html5_api');
        } else {
            return this.myPlayer;
        }
    }

    setVideoOptions = (content, index = -1, isGalleryVideo = false) => {

        let myPlayer = this.getPlayer();

        let videoJsOptions = {
            autoplay: true,
            controls: true,
            poster: content.thumbnail_url,
            sources: [{
                src: content.url,
                type: 'video/mp4',
                withCredentials: true
            }],
            aspectRatio: "16:9"
        }

        let state = {};
        if (isGalleryVideo) {
            state = {
                playingVideo: this.state.videos[index],
                playingIndex: index,
            }
        } else {
            state = {
                content,
            }
        }

        this.setState(state, () => {

            if (myPlayer !== null) {
                myPlayer.pause();
                if (content.hasOwnProperty("url") && content.url !== "") {
                    this.setState({
                        videoJsOptions
                    }, () => {
                        myPlayer.poster(content.thumbnail_url);
                        myPlayer.src({type: 'video/mp4', src: content.url, withCredentials: true});
                        myPlayer.play();
                    })
                } else {
                    myPlayer.poster(content.thumbnail_url);
                }
            }else{
                this.setState({
                    videoJsOptions
                })
            }

            if (this.state.contentList.length === 0) {
                if (content && content.hasOwnProperty("broadcaster") && content.broadcaster.hasOwnProperty("id")) {
                    api.getContentListAPI(this.props, "all", "video", "new", 1, content.broadcaster.id)
                }
            }

            const isGallery = this.props.location.pathname.indexOf("gallery") > 0;
            const isVideo = this.props.location.pathname.indexOf("video") > 0;
            const isPicture = this.props.location.pathname.indexOf("picture") > 0;
            let payload = null;

            if (this.state.playingIndex !== -1 && isGallery) {
                //user is playing gallery but the video is not purchased
                payload = this.state.playingVideo;
                if (payload.hasOwnProperty("url") && payload.url === "") {
                    const subscription = payload.pricing_type !== "exclusive" ? payload.pricing.subscription : 0
                    let prices = pricing.set(payload.pricing.ppm, payload.pricing.price, 0, subscription, "");
                    this.setState({
                        prices
                    }, () => {
                        this.setPremiumContentModalOpen(true)
                    })
                }
            } else if (content.url === "" && isVideo) {
                payload = this.state.content;
                if (payload.hasOwnProperty("url") && payload.url === "") {
                    const subscription = payload.pricing_type !== "exclusive" ? payload.pricing.subscription : 0
                    let prices = pricing.set(payload.pricing.ppm, payload.pricing.price, 0, subscription, "");
                    this.setState({
                        prices
                    }, () => {
                        this.setPremiumContentModalOpen(true)
                    })
                }
            }
        })
    }

    init = () => {

        const isContentPassed = video_util.hasContent(this.props);

        const content = isContentPassed ? this.props.location.state.content : {};
        const isVideo = this.props.location.pathname.indexOf("video") > 0;
        const isGallery = this.props.location.pathname.indexOf("gallery") > 0;
        const isPicture = this.props.location.pathname.indexOf("picture") > 0;

        this.setState({
            "type": (isPicture ? "picture" : (isGallery ? "gallery" : "video"))
        })
        if (isVideo) {
            if (isContentPassed && this.props.location.pathname.indexOf(content.id) > 0) {
                this.setVideoOptions(content)
            } else {
                api.getVideoDetailsByIdAPI(this.props, this.props.match.params.id);
                this.loadingRef.current.continuousStart();
            }
        } else if (isGallery) {
            if (isContentPassed && this.props.location.pathname.indexOf(content.id) > 0) {
                //this.setVideoOptions(content)
                api.getGalleryDetailsByIdAPI(this.props, this.props.match.params.id);
                this.loadingRef.current.continuousStart();
            } else {
                api.getGalleryDetailsByIdAPI(this.props, this.props.match.params.id);
                this.loadingRef.current.continuousStart();
            }
        } else if (isPicture) {
            this.setState({
                content
            })
        }

    }

    constructor(props) {
        super(props);

        this.intervalTimer = null;
        this.loadingRef = React.createRef();
        this.myPlayer = null;

        this.state = {
            prices: pricing.set(0, 0, 0, 0),
            videoJsOptions: {
                autoplay: false,
                controls: true,
                poster: assets.clipstore.home.video_placeholder,
                sources: [{
                    src: "",
                    type: 'video/mp4',
                    withCredentials: true
                }],
                aspectRatio: "16:9"
            },
            content: {},
            contentList: [],
            videos: [],
            playingVideo: {},
            playingIndex: -1,
            perVideoPaid: false,
            ppmPaid: false,
            isPremiumContentModalOpen: false,
            isGalleryVideoOpen: true,
            type: 'video'
        }
    }

    componentDidMount() {
        this.init();

    }

    resetMemory = ()=> {
        this.myPlayer = null;
        clearInterval(this.intervalTimer)
    }

    componentWillUnmount() {
        this.resetMemory();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {


        if (nextProps.match &&
            nextProps.match.hasOwnProperty("params") &&
            nextProps.match.params.hasOwnProperty("id") &&
            nextProps.match.params.id !== this.props.match.params.id) {


            const isVideo = nextProps.location.pathname.indexOf("video") > 0;
            const isGallery = nextProps.location.pathname.indexOf("gallery") > 0;

            if (isVideo) {
                api.getVideoDetailsByIdAPI(this.props, nextProps.match.params.id);
                this.loadingRef.current.continuousStart();
            } else if (isGallery) {
                api.getGalleryDetailsByIdAPI(this.props, nextProps.match.params.id);
                this.loadingRef.current.continuousStart();
            }
        }

        //this will be called for every pagination we perform
        if (nextProps.get_content_list && nextProps.get_content_list.payload !== this.props.get_content_list.payload) {

            if (nextProps.get_content_list.payload &&
                nextProps.get_content_list.payload.hasOwnProperty("data") &&
                nextProps.get_content_list.payload.data.hasOwnProperty("data")) {

                let data = nextProps.get_content_list.payload.data;

                this.setState({
                    contentList: data.data
                })
            }
        }

        //handle the API response for accessing the video details
        library.handleAPIResponse(nextProps, "get_video_details", () => {
            //reset the payload value as we have captured the event
            this.props.resetGetVideoDetailsById();
            this.loadingRef.current.complete();
        }, () => {
            //check if url is present and then take decision
            const payload = nextProps.get_video_details.hasOwnProperty("payload") &&
                nextProps.get_video_details.payload.hasOwnProperty("success") &&
                nextProps.get_video_details.payload.success.hasOwnProperty("data") &&
                nextProps.get_video_details.payload.success.data;

            this.setVideoOptions(payload)

        }, () => {
            //nothing to handle
        },true,false)

        //handle the API response for accessing the video details
        library.handleAPIResponse(nextProps, "get_gallery_details", () => {
            //reset the payload value as we have captured the event
            this.props.resetGetGalleryDetailsById();
            this.loadingRef.current.complete();
        }, () => {
            //check if url is present and then take decision
            const payload = nextProps.get_gallery_details.hasOwnProperty("payload") &&
                nextProps.get_gallery_details.payload.hasOwnProperty("success") &&
                nextProps.get_gallery_details.payload.success.hasOwnProperty("data") &&
                nextProps.get_gallery_details.payload.success.data;


            if (payload && payload.hasOwnProperty("pricing")) {
                if (payload && payload.hasOwnProperty("url") && payload.url === "") {
                    // const subscription = payload.pricing_type !== "exclusive" ? payload.pricing.subscription : 0
                    // let prices = pricing.set(payload.pricing.ppm, payload.pricing.price, 0, subscription, "");
                    // this.setState({
                    //     prices
                    // }, () => {
                    //     this.setPremiumContentModalOpen(true)
                    // })
                } else {
                    this.setState({
                        videos: payload.videos,
                        playingIndex: -1
                    })
                    this.setVideoOptions(payload)
                }
            }
        }, () => {
            //nothing to handle
        },true,false)

        //handle the API response for purchase content response
        library.handleAPIResponse(nextProps, "purchase_content", () => {
            //reset the payload value as we have captured the event
            this.loadingRef.current.complete();
            this.props.resetPurchaseContent();

        }, () => {
            //check if url is present
            //we have the url let's go onto detail page
            window.location.reload();
        }, () => {
            //nothing to handle
        })

        //handle the API response for subscription
        library.handleAPIResponse(nextProps, "subscribe_to_broadcaster", () => {
            //reset the payload value as we have captured the event
            this.loadingRef.current.complete();
            this.props.resetSubscribeToBroadcaster();

        }, () => {
            //check if url is present
            //we have the url let's go onto detail page
            window.location.reload();
        }, () => {
            //nothing to handle
        })
    }

    setGalleryVideoOpen = (status) => {
        this.setState({
            isGalleryVideoOpen: status ? status : !this.state.isGalleryVideoOpen
        })
    }

    onPlayerReady = (player, videoNode) => {
        this.myPlayer = player;
        this.myPlayer.play();

        this.intervalTimer = setInterval(() => {
            if (this.myPlayer !== null) {
                if (!this.myPlayer.paused()) {
                    const currentTime = this.myPlayer.currentTime();
                    const remainingTime = this.myPlayer.remainingTime();
                    if(parseInt(remainingTime) === 1){
                        setTimeout(()=>{
                            let playingIndex = this.state.playingIndex;
                            let videos = this.state.videos;
                            let length = videos.length;
                            if((playingIndex+1) < length){
                                playingIndex = playingIndex + 1;
                                this.setVideoOptions(this.state.videos[playingIndex], playingIndex, true)
                            }
                        },1000)
                    }
                }
            }

        }, 1000);
    }

    setPremiumContentModalOpen = (isPremiumContentModalOpen) => {
        this.setState({
            isPremiumContentModalOpen: isPremiumContentModalOpen
        })
    }

    showLogin = () => {
        this.props.history.push(
            {
                pathname: '/login',
                state: {
                    basePath: this.props.history.location.pathname,
                    search: _get(this.props, 'history.location.search', '')
                }
            }
        );
    };

    showRequestTipModal = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.showTipModal();
            } else {
                this.showLogin();
            }
        });
    };

    isVideo = () => {
        if(this.state.type !== "picture"){
            if(this.state.type === "gallery"){
                if (this.state.content.hasOwnProperty("pictures") && this.state.content.hasOwnProperty("videos")) {
                    const pictures = this.state.content.pictures;
                    const videos = this.state.content.videos;

                    if (pictures && Array.isArray(pictures) && pictures.length > 0) {
                        return false;
                    }
                }
            }

            return true;
        }

        return false;
    }

    renderCarousel = () => {

        if ((this.state.type === "picture" || this.state.type === "gallery") && this.state.content && this.state.content.hasOwnProperty("title")) {
            if (this.state.content.hasOwnProperty("pictures") && Array.isArray(this.state.content.pictures) && this.state.content.pictures.length > 0) {
                return (
                    <Carousel showArrows={false} dynamicHeight={true}>
                        {
                            this.state.content.pictures.map((picture) => {
                                return (
                                    <Zoom key={`carousel-image-${picture.id}`}>
                                        <img src={picture.url} alt={picture.title} className="carousel-main-image"/>
                                        <p className="legend">{picture.title}</p>
                                    </Zoom>
                                )
                            })
                        }
                    </Carousel>
                )
            } else {
                return (
                    <Zoom>
                        <img height="400"
                             alt={this.state.content.title}
                             src={this.state.content.url}/>
                    </Zoom>
                )
            }
        }
    }

    render() {

        const tags = video_util.getTags(this.state.content);
        return (
            <main role="main" className="container-fluid">

                <LoadingBar color='#f11946' ref={this.loadingRef}/>

                <LikeContainer {...this.props} content={this.state.content}/>

                {
                    this.state.content &&
                    this.state.content.hasOwnProperty("id") &&
                    <PremiumContentModal

                        isOpen={this.state.isPremiumContentModalOpen}
                        toggle={(key,value) => {
                            this.setPremiumContentModalOpen(false)
                        }}

                        setPaymentChoice={(value) => {
                            const payload = this.state.playingIndex === -1 ? this.state.content : this.state.playingVideo;
                            pricing.setPaymentChoice(value, payload, (prices) => {
                                this.setState({
                                    prices
                                })
                            })
                        }}
                        prices={this.state.prices}
                        content={this.state.playingIndex === -1 ? this.state.content : this.state.playingVideo}
                        buy={(price) => {
                            this.setState({
                                selectedPricing: price[0]
                            })
                            const payload = this.state.playingIndex === -1 ? this.state.content : this.state.playingVideo;
                            pricing.purchaseContent(this.props, payload, price[0])
                        }}
                        showLogin={this.showLogin}
                        purchase_content={this.props.purchase_content}

                        history={this.props.history}
                        location={this.props.location}

                        setWalletBalance={this.props.setWalletBalance}
                        showMoneyBloxModal={this.props.showMoneyBloxModal}
                    />
                }

                <div>
                    <Row className={"broadcast-container-parent"} style={{marginTop: 24}}>
                        <Col md="8" className="home-container">
                            {
                                this.isVideo() ?
                                    <div className="bg-white" style={{paddingBottom: 10}}>
                                        {
                                            video_util.isVideoURLPresent(this.state.videoJsOptions)
                                                ?
                                                video_util.posterImage(this.state.videoJsOptions, () => {
                                                    if (this.state.videos.length > 0) {
                                                        this.setVideoOptions(this.state.videos[0], 0, true)
                                                    } else {
                                                        vuepayAlert("error", "No videos in the gallery")
                                                    }
                                                })
                                                :
                                                <VideoPlayer {...this.state.videoJsOptions}
                                                             onPlayerReady={this.onPlayerReady}/>
                                        }
                                    </div>
                                    :
                                    <div className="display-flex-justify-center">
                                        {
                                            this.renderCarousel()
                                        }
                                    </div>
                            }
                            {
                                this.props.location.pathname.indexOf("gallery") > 0 && this.isVideo() &&
                                <div className={classnames("bg-white", {
                                    "gallery-videos-container-open": this.state.isGalleryVideoOpen,
                                    "gallery-videos-container-close": !this.state.isGalleryVideoOpen
                                })}>
                                    <div className="gallery-videos-container">
                                        <div className="gallery-videos-container-title">
                                            Gallery videos
                                            ({this.state.content.hasOwnProperty("videos") && this.state.content.videos.length})
                                        </div>
                                        <img
                                            src={this.state.isGalleryVideoOpen ? assets.clipstore.home.arrow_up : assets.clipstore.home.arrow_down}
                                            alt="arrow up & down"
                                            style={{cursor: 'pointer'}}
                                            onClick={() => {
                                                this.setGalleryVideoOpen(null)
                                            }}
                                            height={10}
                                        />
                                    </div>
                                    <Collapse isOpen={this.state.isGalleryVideoOpen}>
                                        <div className="gallery-videos-container-collapse">
                                            {
                                                this.state.content.hasOwnProperty("videos") && this.state.content.videos.map((content, index) => {
                                                    return (
                                                        <MoreVideo
                                                            playing={this.state.playingIndex === index}
                                                            index={index}
                                                            horizontal={true}
                                                            key={`galleries-video-${index}`}
                                                            content={content}
                                                            openDetail={(content, index) => {
                                                                this.setVideoOptions(content, index, true)
                                                            }}
                                                        />
                                                    )
                                                })
                                            }
                                        </div>
                                    </Collapse>
                                </div>
                            }
                            {
                                this.state.content.hasOwnProperty("id") &&
                                <div className="bg-white" style={{padding: "0px 16px 16px 16px"}}>
                                    <HomeCardComponent
                                        showRequestTipModal={this.showRequestTipModal}
                                        openBroadcasterProfile={(content)=>{
                                            const encryptBroadcasterId = getEncryptedIdForBroadcaster(content.broadcaster.id)
                                            this.props.history.push(`/profile/${encryptBroadcasterId}`);
                                        }}
                                        openDetail={(content, index) => {
                                        }}
                                        perVideoPaid={false}
                                        ppmPaid={false}
                                        isDetailModal={true}
                                        isDetailPage={true}

                                        content={this.state.content}
                                        key={`home-detail-card-component-${this.state.content.id}`}/>

                                    <div className="premium-content-modal-description">
                                        {this.state.content.description}
                                    </div>


                                    <div className="premium-content-modal-tags">
                                        Tags:
                                        {
                                            tags.map((tag, index) => {
                                                return (
                                                    <span className="premium-content-modal-tag"
                                                          key={`premium-content-modal-tag-${index}`}>{tag.name}</span>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            }

                            <Comments
                                match={this.props.match}
                                history={this.props.history}
                                location={this.props.location}/>
                        </Col>

                        <Col md="4" className="home-container">
                            <div className="bg-white mode-videos-for-broadcaster">
                                <div className="mode-videos-for-broadcaster-title">More Videos from broadcaster</div>

                                {
                                    this.state.contentList.map((content, index) => {
                                        return (
                                            <MoreVideo
                                                index={index}
                                                key={`more-video-${index}`}
                                                content={content}
                                                openDetail={(content, index) => {

                                                    clearInterval(this.intervalTimer);

                                                    if (content.type === "video") {
                                                        //we have the url let's go onto detail page
                                                        this.props.history.push(`/video/${content.id}`, {
                                                            content: null
                                                        });
                                                    } else if (content.type === "gallery") {
                                                        this.props.history.push(`/gallery/${content.id}`, {
                                                            content:null
                                                        });
                                                    }
                                                }}
                                            />
                                        )
                                    })
                                }

                            </div>
                        </Col>
                    </Row>
                </div>
            </main>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        flag: state.flag,
        device: state.device.payload,
        get_content_list: state.get_content_list,
        get_video_details: state.get_video_details,
        get_gallery_details: state.get_gallery_details,

        purchase_content: state.purchase_content,
        subscribe_to_broadcaster: state.subscribe_to_broadcaster,
        moneyblox: state.moneyblox,
        broadcaster_detail_management: state.broadcaster_detail_management
    };
}

export default connect(mapStateToProps, actions)(VideoDetails);

